<template>
  <div class="offer-x">
    <el-form :model="form" ref="offerForm" label-width="120px">
      <!-- 材料选择 -->
      <el-form-item label="材料选择" prop="cl">
        <el-select v-model="form.cl" placeholder="请选择材料" @change="submitGetPrice">
          <el-option v-for="(product, index) in products" :key="index" :label="product.name" :value="product.id" />
        </el-select>
      </el-form-item>

      <!-- 成品规格 -->
      <el-form-item label="成品规格">
        <el-input-number v-model="form.long" :min="0" @change="submitGetPrice" />
        <span style="margin-right:10px;">X</span>
        <el-input-number v-model="form.wide" :min="0" @change="submitGetPrice" />
        <span style="margin-left:10px;">单位mm</span>
        <el-select v-model="form.zdks" placeholder="同尺寸一款内容" @change="submitGetPrice">
          <el-option value="zdks_00" label="同尺寸一款内容">同尺寸一款内容</el-option>
          <el-option value="zdks_01" label="二款合并下单">二款合并下单</el-option>
          <el-option value="zdks_02" label="三款合并下单">三款合并下单</el-option>
          <el-option value="zdks_03" label="四款合并下单">四款合并下单</el-option>
          <el-option value="zdks_04" label="五款合并下单">五款合并下单</el-option>
          <el-option value="zdks_05" label="六款至十款合并下单">六款至十款合并下单</el-option>
          <el-option value="zdks_06" label="十一款至二十款合并下单">十一款至二十款合并下单</el-option>
          <el-option value="zdks_07" label="二十一至四十款合并下单">二十一至四十款合并下单</el-option>
          <el-option value="zdks_08" label="41款以上, 99款内">41款以上, 99款内</el-option>
          <el-option value="zdks_09" label="100款以上 且需分">100款以上 且需分款</el-option>
        </el-select>
      </el-form-item>

      <!-- 出货形式 -->
      <el-form-item label="出货形式">
        <el-radio-group v-model="form.typecl" size="medium" @change="submitGetPrice">
          <el-radio border label="typecl_01">卷装出货</el-radio>
          <el-radio border label="typecl_02">片张出货</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="颜色要求">
        <el-radio-group v-model="form.ysyq" size="medium" @change="submitGetPrice">
          <el-radio border label="ysyq_01">正常印刷</el-radio>
          <el-radio border label="ysyq_02">简单跟色样</el-radio>
          <el-radio border label="ysyq_03">来厂跟色</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 表面工艺 -->
      <el-form-item label="表面工艺">
        <el-radio-group v-model="form.bmgy" @change="submitGetPrice">
          <el-radio border label="bmgy_01">覆光膜</el-radio>
          <el-radio border label="bmgy_02">覆哑膜</el-radio>
          <el-radio border label="bmgy_03">不覆膜</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 成品模式 -->
      <el-form-item label="表面增效">
        <el-radio-group v-model="form.bmzx" @change="submitGetPrice">
          <el-radio border label="bmzx_01">无</el-radio>
          <el-radio border label="bmzx_02">白墨</el-radio>
          <el-radio border label="bmzx_03">磨砂</el-radio>
          <el-radio border label="bmzx_04">白墨+磨砂</el-radio>
          <el-radio border label="bmzx_05">光油</el-radio>
          <el-radio border label="bmzx_06">哑油</el-radio>
          <el-radio border label="bmzx_07">数码烫金I银</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="卷芯直径" v-if="form.typecl=='typecl_01'">
        <el-radio-group v-model="form.attr_jxzj">
          <el-radio :label="27">76㎜机贴</el-radio>
          <el-radio :label="28">40㎜小机</el-radio>
          <el-radio :label="29">25㎜小机</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="出标方向" v-if="form.typecl=='typecl_01'">
        <el-select v-model="form.attr_cbfx" placeholder="请选择" style="width: 240px">
          <el-option v-for="item in directionOptions" :key="item.value" :label="item.label" :value="item.value">
            <div style="display:flex;align-items:center;">
              <img :src="item.image" style="width:40px;height:40px;margin-right:10px;" />
              <span>{{ item.label }}</span>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出标方式" v-if="form.typecl=='typecl_01'">
        <el-select v-model="form.attr_cblx" placeholder="请选择" style="width: 240px">
          <el-option v-for="item in edgeOptions" :key="item.value" :label="item.label" :value="item.value">
            <div style="display:flex;align-items:center;">
              <img :src="item.image" style="width:40px;height:40px;margin-right:10px;" />
              <span>{{ item.label }}</span>
            </div>
          </el-option>
        </el-select>
      </el-form-item>

      <!-- 成品数量 -->
      <el-form-item label="成品数量">
        <div class="number-select">
          <div
            v-for="item in numberOptions"
            :key="item.quantity"
            class="number-item"
            :class="{ active: form.number === item.quantity }"
            @click="selectNumber(item.quantity)"
          >
            <div class="num">{{ item.quantity }}</div>
            <div class="price">￥{{ item.total_price }}</div>
          </div>
        </div>

        <div style="margin-top:15px;display:flex;align-items:center;">
          <el-input-number v-model="form.customNumber" placeholder="自定义数量" :min="0" @change="onCustomChange" />
          <span style="margin-left:15px;color:#e6a23c;">￥{{ customPrice || 0 }}</span>
        </div>
      </el-form-item>

      <!-- 交货方式 -->
      <el-form-item label="交货方式">
        <el-radio-group v-model="form.delivery_method">
          <el-radio border label="delivery_method_1">自取</el-radio>
          <el-radio border label="delivery_method_2">快递</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="联系人" v-if="form.delivery_method=='delivery_method_2'">
        <el-input v-model="form.customername" placeholder="请输入联系人" />
      </el-form-item>
      <el-form-item label="联系电话" v-if="form.delivery_method=='delivery_method_2'">
        <el-input v-model="form.customerphone" placeholder="请输入联系电话" />
      </el-form-item>
      <el-form-item label="省市" v-if="form.delivery_method=='delivery_method_2'">
        <el-cascader v-model="form.region" ref="regionCascader" :options="regionOptions" placeholder="请选择省市" @change="onRegionChange" />
      </el-form-item>
      <el-form-item label="收货地址" v-if="form.delivery_method=='delivery_method_2'">
        <el-input v-model="form.address" placeholder="请输入收货地址" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="form.remark" :rows="2" />
      </el-form-item>
      <div style="display:flex;justify-content:space-between;margin-top:20px;">
        <div>
          <span style="color:#888;">不包邮：</span>
          <span style="color:#f56c6c;font-size:26px;">￥{{ orderPrice }}</span>
        </div>

        <div>
          <span style="color:#888;">另付运费：</span>
          <span style="color:#f56c6c;font-size:16px;">￥{{ expressPrice }}</span>
        </div>
      </div>

      <!-- 下单按钮 -->
      <el-form-item>
        <el-button type="primary" @click="submitForm">下单传文件</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
 

<script>
import { getProducts } from '@/api/product'
import { getOrderPrice } from '@/api/order'
import { allCity } from '@/utils/city'
export default {
  name: 'HomeView',
  mounted() {},
  created() {
    this.requestData()
    this.regionOptions = this.buildTree(allCity())
  },
  data() {
    return {
      form: {
        cl: '',
        long: 40,
        wide: 30,
        typecl: 'typecl_01',
        bmgy: 'bmgy_01',
        ysyq: 'ysyq_01',
        zdks: 'zdks_00',
        bmzx: 'bmzx_01',
        number: 500,
        customPrice: null,
        customNumber: null,
        delivery_method: 'delivery_method_1',
        customername: '',
        customerphone: '',
        customer_province: '',
        customer_city: '',
        address: '',
        remark: ''
      },
      orderPrice: 0,
      expressPrice: 0,
      customPrice: 0,
      directionOptions: [
        {
          value: 23,
          label: '上出标',
          image: 'https://www.yinbq.com/uploads/20220512/a7fe8805adb6a3883420a8a7f897c839.jpg'
        },
        {
          value: 24,
          label: '下出标',
          image: 'https://www.yinbq.com/uploads/20220512/602f9b25529a23951866795ef620bdc1.jpg'
        },
        {
          value: 25,
          label: '左出标',
          image: 'https://www.yinbq.com/uploads/20220512/05fe74becbd02b831af872068bda087f.jpg'
        },
        {
          value: 26,
          label: '右出标',
          image: 'https://www.yinbq.com/uploads/20220512/38cd5c16c47901ae440759e2f37fa65b.jpg'
        }
      ],
      edgeOptions: [
        {
          value: 39,
          label: '长边出标',
          image: 'https://www.yinbq.com/uploads/20251111/0edd433442ea98ce398b5def6be4c118.jpg'
        },
        {
          value: 40,
          label: '短边出标',
          image: 'https://www.yinbq.com/uploads/20251111/861a8bfbb6d982e06a349f6cbaea3868.jpg'
        }
      ],
      numberOptions: [
        { quantity: 500, total_price: 0 },
        { quantity: 1000, total_price: 0 },
        { quantity: 2000, total_price: 0 },
        { quantity: 3000, total_price: 0 },
        { quantity: 5000, total_price: 0 },
        { quantity: 10000, total_price: 0 }
      ],
      products: [],
      provinces: ['广东省', '浙江省', '江苏省'],
      cities: ['深圳市', '广州市', '东莞市'],
      regionOptions: []
    }
  },

  methods: {
    onRegionChange() {
      const nodes = this.$refs.regionCascader.getCheckedNodes()

      if (!nodes.length) return

      const node = nodes[0]

      this.form.customer_province = node.pathLabels[0] // 省名称
      this.form.customer_city = node.pathLabels[1] // 市名称
    },
    buildTree(list) {
      const map = {}
      const result = []

      // 只建节点（不预设 children）
      list.forEach(item => {
        map[item.regid] = {
          value: item.regid,
          label: item.regname
        }
      })

      // 只处理两级关系
      list.forEach(item => {
        const node = map[item.regid]

        // 省
        if (item.parid === '1') {
          result.push(node)
        }
        // 市
        else {
          const parent = map[item.parid]
          if (parent) {
            if (!parent.children) {
              parent.children = []
            }
            parent.children.push(node)
          }
        }
      })

      return result
    },
    selectNumber(val) {
      this.form.number = val
      this.form.customNumber = null // 清空自定义

      this.submitGetPrice()
    },
    async onCustomChange(val) {
      if (!val) return

      this.form.number = null
      this.submitGetPrice()
    },
    async submitGetPrice() {
      try {
        const res = await getOrderPrice(this.form)
        console.log(res)
        this.numberOptions = res.totalPrice
        this.customPrice = res.customPrice
      } catch (err) {
        console.error(err)
        this.error = '加载失败'
      } finally {
        this.loading = false
      }
    },
    async submitForm() {},
    async requestData() {
      this.loading = true
      this.error = ''

      try {
        const res = await getProducts({ cid: 1 })
        console.log(res)
        const list = Array.isArray(res) ? res : res.data || []

        console.log(list)
        // 加 open 控制展开
        this.products = list
      } catch (err) {
        console.error(err)
        this.error = '加载失败'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  height: 356px;
  overflow: hidden;
}
.offer-x {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  padding-left: 260px;
}
.entry-wrap {
  background: #fff;
  padding: 40px 0;

  .entry-1200 {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .entry-item {
      width: 23%;
      cursor: pointer;
      background: #f8f8f8;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-6px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
      }

      .img-box {
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }
      }

      .info {
        padding: 18px;

        .title {
          font-size: 18px;
          font-weight: bold;
          display: flex;
          align-items: center;

          .bar {
            width: 4px;
            height: 18px;
            background: #409eff;
            margin-right: 8px;
          }
        }

        .desc {
          margin-top: 10px;
          font-size: 14px;
          color: #666;
          line-height: 1.6;
        }
      }
    }
  }
}
.order-flow {
  max-width: 1200px;
  margin: 100px auto;
  text-align: center;

  .title {
    font-size: 36px;
    font-weight: bold;
    color: #333;

    p {
      font-size: 16px;
      color: #666;
      margin-top: 10px;
      position: relative;
      display: inline-block;

      &::before,
      &::after {
        content: '';
        width: 120px;
        height: 1px;
        background: #ddd;
        position: absolute;
        top: 50%;
      }

      &::before {
        left: -140px;
      }

      &::after {
        right: -140px;
      }
    }
  }

  .el-steps {
    margin-top: 60px;
  }

  .el-step__title {
    font-size: 18px;
    font-weight: bold;
  }

  .el-step__description {
    font-size: 14px;
    line-height: 1.6;
  }

  .el-step__icon {
    font-size: 28px;
  }
}
.number-select {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.number-item {
  width: 110px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  padding: 10px 0;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
}

.number-item .num {
  font-size: 16px;
  font-weight: bold;
}

.number-item .price {
  margin-top: 5px;
  color: #666;
}

.number-item.active {
  border-color: #f7ba2a;
  background-color: #fff7e6;
  color: #e6a23c;
}
</style>
